import { BrowserRouter as Router, Route, Routes, NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;


const News = () => {
	const [articles, setArticles] = useState([]);
	const [banners, setBanners] = useState([]);
	const [viewMode, setViewMode] = useState("grid");
	const [page, setPage] = useState(1);
  	const [perPage] = useState(15);
  	const [totalPages, setTotalPages] = useState(1);
  	const [err, setErr] = useState(null);
  	const [loading, setLoading] = useState(true);
	
	const topnewslider = {
	  dots: true,
	  infinite: true,
	  speed: 500,
	  centerMode: true,
	  centerPadding: '60px',
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  responsive: [
	  {
	    breakpoint: 768,
	    settings: {
	      slidesToShow: 1
	    }
	  }
	  ]
	};

	const fetchNews = async (p = 1) => {
	    try {
	      window.scrollTo({ top: 0, behavior: "smooth" });
	      setErr(null);
	      const res = await fetch(`${apiUrl}/get-news?page=${p}&per_page=${perPage}`);
	      if (!res.ok) throw new Error(`HTTP ${res.status}`);
	      const data = await res.json();

	      setArticles(data.items || []);
	      setBanners(data.banner || []);
	      setTotalPages(data?.meta?.last_page ?? 1);
	      setPage(data?.meta?.current_page ?? p);
	    } catch (e) {
	      console.error("Error fetching news:", e);
	      setErr("Failed to load news.");
	    } finally {
	      setLoading(false);
	    }
	 };

	useEffect(() => {
		fetchNews(1);
	}, []);

	const handlePrev = () => {
	    if (page > 1) fetchNews(page - 1);
	};

	const handleNext = () => {
	    if (page < totalPages) fetchNews(page + 1);
	};

	const formatDate = (dateString) => {
	  const date = new Date(dateString);
	  return date.toLocaleString('en-US', {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: '2-digit',
	    hour12: true
	  });
	};

return (
	<>
	    <div className="news_wrapper">
			<div className="news_mainsec">
				<div className="topnews_mainsec">
					<div className="container-fluid">
						<div className="topnews_mainbox">
							{banners.map((item, index) => {
							    if (item.Source === 'Cointelegraph') return null; // 👈 Skip this item

							    return (
							        <div
									  key={index}
									  className={`topnewsbox ${index === 2 ? 'center_bigbox' : ''}`}
									  style={{ backgroundImage: `url(${item.image})` }}
									>
							            <div className="contntbox">
							                <h2>{item.title}</h2>
							                <div className="sortdes"><p dangerouslySetInnerHTML={{ __html: item.description }}></p></div>

							                <div className="txtbtn">
							                    <a
							                        className="btn_style"
							                        href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${item.Source}`}
							                    >
							                        View More
							                    </a>
							                </div>
							            </div>
							        </div>
							    );
							})}
						</div>
					</div>
				</div>
				
				<div className="news_boxsec">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<div className="toptitlebox">
									<div className="titlesec">
										<h2>Latest Crypto News</h2>
										<p>Stay updated with breaking news and market-moving events</p>
									</div>
									
									<div className="view-toggle">
										<button onClick={() => setViewMode("grid")} className={viewMode === "grid" ? "active" : ""}>
											<i className="fas fa-border-all"></i>
										</button>
										
										<button onClick={() => setViewMode("list")} className={viewMode === "list" ? "active" : ""}>
											<i className="fas fa-list"></i>
										</button>
									</div>
								</div>
							</div>
						</div>
						
						<div className="row">
							<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<div className="articals_mainsec">
									{articles.map((item, index) => (
										<div className={`articals_mainbox ${viewMode}`}>
											<div className="articals_innerbox">
												<div className="articals_imgbox">
													<a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${item.Source}`}><img src={item.image} alt={item.title} /></a>
												</div>
												
												<div className="articals_contntbox">
													<div className="artical_contnt">
														<h3><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${item.Source}`}>{item.title}</a></h3>
														<p className="article_description" dangerouslySetInnerHTML={{ __html: item.description }}></p>
													</div>
													
													<div className="share_social_sec">
														<span className="titletxt">Share:</span>
														<ul>
															<li>
																<a
																  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}`}
																  target="_blank"
																  rel="noopener noreferrer"
																><i className="fab fa-facebook-f"></i>
															</a>
															</li>
															<li>
																<a
																  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}`}
																  target="_blank"
																  rel="noopener noreferrer"
																><i className="fab fa-linkedin-in"></i>
																</a>
															</li>
															<li>
																<a
																  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}&text=${encodeURIComponent(item.title)}`}
																  target="_blank"
																  rel="noopener noreferrer"
																><i className="fab fa-twitter"></i>
																</a>
															</li>
															<li>
																<a
																  href={`https://t.me/share/url?url=${encodeURIComponent(`${homeUrl}artical/${item.title}`)}&text=${encodeURIComponent(item.title)}`}
																  target="_blank"
																  rel="noopener noreferrer"
																><i class="fab fa-telegram-plane"></i>
																</a>
															</li>
														</ul>
													</div>
													
													<div className="artical_info">
														<div className="datetimebox">
															<span className="datetime">
																<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-calendar h-3 w-3"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path></svg>
																
																<span className="datetxt">{formatDate(item.pubDate)}</span>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									))}
								</div>
								<div className="btn_mainsec pagination mt-4">
						            <button onClick={handlePrev} disabled={page <= 1} className="btn_style">
						              Prev
						            </button>
						            <span>
						              Page {page} / {totalPages}
						            </span>
						            <button onClick={handleNext} disabled={page >= totalPages} className="btn_style">
						              Next
						            </button>
						        </div>
							</div>
						</div>
					</div>
				</div>
			</div>
	    </div>
	   	{loading && (
		<div className="loader_mainbox">
			<div className="loader_mainsec">
				<div className="loader market-spinner">
					<svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-label="Loading market data">
					<polyline points="22 7 13.5 15.5 8.5 10.5 2 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					<polyline points="16 7 22 7 22 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</div>
					 
				<div className="text-loader">
					<span>C</span>
					<span>O</span>
					<span>I</span>
					<span>N</span>
					<span>V</span>
					<span>I</span>
					<span>E</span>
					<span>W</span>
					<span>S</span>
				</div>
			</div>
		</div>
		)}
	</>
  );
};

export default News;